export const toastClassName = 'my-16 -right-3'
